<template>
  <a
    v-if="href"
    class="button"
    :class="containerClass"
    :href="isLink"
    @mouseenter="_isEnter"
    @focus="_isEnter"
    @blur="_isLeave"
    @click="_isClick"
    @mouseleave="_isLeave">
    <template v-if="hasIcon">
      <span class="icon" :class="iconClass"></span>
    </template>
    <span class="label"><slot></slot></span>
  </a>

  <button
    v-else
    class="button"
    :type="type"
    :class="containerClass"
    @mouseenter="_isEnter"
    @focus="_isEnter"
    @blur="_isLeave"
    @click="_isClick"
    @mouseleave="_isLeave">
    <template v-if="hasIcon">
      <span class="icon" :class="iconClass"></span>
    </template>
    <span class="label"><slot></slot></span>
  </button>
</template>

<style lang="less" scoped>

  @import '../assets/styles/buttons';

  .button{
    .make_simple_button(@blue);
    letter-spacing: -0.31px;
    margin: 0 @xs-spacer;

    .icon{
      font-size: @lg-font-size;
      margin-right: @xs-spacer - 5px;
    }

    .label{
      position: relative;
      &::before{
        content: "";
        bottom: -2px;
        left: 0;
        height: 2px;
        display: block;
        position: absolute;
        width: 0;
        .transition(width, .35s, @ease-in-cubic);
        will-change: width
      }
    }

    &.enter{
      .label::before{
        width: 100%;
        .transition(width, .35s, @ease-in-cubic);
      }
    }
    &.active{
      .label::before{
        left: auto;
        right: 0;
        width: 0;
        .transition(width, .35s, @ease-in-out-quint);
      }
    }
    &.pink { .make_simple_button(@pink) }
    &.purple  { .make_simple_button(@purple) }
    &.green  { .make_simple_button(@light-green) }
    &.light-blue  { .make_simple_button(@light-blue) }
  }

</style>

<script>
  import { State } from '../data/State'

  export default {
    props: {
      icon: String,
      type: {
        type: String,
        default: 'button'
      },
      href: String
    },
    data() {
      return {
        state: ''
      }
    },
    methods: {
      _isEnter() {
        this.state = State.enter;
      },
      _isLeave() {
        this.state = '';
      },
      _isClick() {
        this.state = State.active;
      }
    },
    computed: {
      iconClass() {
        return `icon-${this.icon}`
      },
      hasIcon() {
        return this.icon && this.icon.length > 0
      },
      containerClass() {
        return this.state
      },
      isLink() {
        return this.href
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SimpleButton.vue?47a4c1a8